import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import 'daterangepicker';

import { formatDate } from './utils';

const DatePicker = (props) => {

    const handleDateChange = (event, picker) => {
        props.updateDate(formatDate(picker.startDate));
    };

    const handleDateReset = () => {
        $(`input[name="${props.name}"]`).val("");
        props.resetDate();
    };

    useEffect(() => {
        const $datePicker = $(`input[name="${props.name}"]`);
        $datePicker.daterangepicker({
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            minYear: 1901,
            maxYear: parseInt(new Date().getFullYear(), 10),
            locale: {
                format: 'MM/DD/YYYY',
                cancelLabel: "Reset",
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            },
        });
        $datePicker.on("apply.daterangepicker", handleDateChange);
        $datePicker.on("cancel.daterangepicker", handleDateReset);

        $datePicker.data("daterangepicker");

        $datePicker.val("");

        return () => {
            $datePicker.off();
            $datePicker.data("daterangepicker")?.remove();
        };
    }, []);

    return <input type = "text" name = { props.name } className = "form-control d-inline-block w-auto p-2" />;
};

DatePicker.propTypes = {
    name: PropTypes.string,
    updateDate: PropTypes.func,
    resetDate: PropTypes.func
};

export default DatePicker;